import React, { useState } from 'react';
import { A } from 'hookrouter';
import { getValues, format } from '../tables/shared/FormatDetails';
import { useTranslation } from 'react-i18next';
import { CUSTOMER_INVOICE_INFO_CONSULTANT_COL, CUSTOMER_INVOICE_INFO_DATE_COL, CUSTOMER_INVOICE_INFO_HOURS_COL, CUSTOMER_INVOICE_INFO_INVOICE_NUM_COL, CUSTOMER_INVOICE_INFO_LATEST_INVOICE_AMOUNT_COL, CUSTOMER_INVOICE_INFO_NO_INVOICE_WARN } from '../../i18n/keyConstants';

export default function CustomerInvoiceInfo({ customerInvoiceInfo, customer }) {
    const [searchValue, setSearchValue] = useState('');

    const getResults = (consultant, invoiceInformation) => {
        const results = getValues(consultant, invoiceInformation);
        return results;
    };
    const { t } = useTranslation(['customerInvoiceInfo']);

    return (
        <div>
            <div className='padding-top-30px customer-invoice'>
                <div className='justify-content-between'>
                    {customerInvoiceInfo.invoiceInformation && customerInvoiceInfo.invoiceInformation.length ? (
                        <table className='table-striped table-border'>
                            <thead>
                                <tr>
                                    <th className='padding-left-10px'>{t(CUSTOMER_INVOICE_INFO_DATE_COL)}</th>
                                    <th>
                                        <input
                                            className='thInput'
                                            type='text'
                                            placeholder={t(CUSTOMER_INVOICE_INFO_CONSULTANT_COL) }
                                            onChange={(e) => setSearchValue(e.target.value)}
                                        />
                                    </th>
                                    <th className='align-right '>{t(CUSTOMER_INVOICE_INFO_HOURS_COL)}</th>
                                    <th className='align-right'>{t(CUSTOMER_INVOICE_INFO_LATEST_INVOICE_AMOUNT_COL)}</th>
                                    <th className='padding-right-10px'>{t(CUSTOMER_INVOICE_INFO_INVOICE_NUM_COL)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getResults(searchValue, customerInvoiceInfo.invoiceInformation).filtered.map((invoice, index) => (
                                    <tr key={index}>
                                        <td className='padding-left-10px year-month'>
                                            {invoice.month.substring(0, 4) + '-' + invoice.month.substring(invoice.month.length - 2)}
                                        </td>
                                        <td className='consultant'>
                                            {invoice.empName !== '' ? (
                                                <A className='kam' href={`/employee/${invoice.empId}/info`}>
                                                    {invoice.empName}
                                                </A>
                                            ) : (
                                                invoice.empName
                                            )}
                                        </td>
                                        <td className='align-right hours'>{invoice.invoiceHours ? format(invoice.invoiceHours, 1) : ''}</td>
                                        <td className='align-right invoice-amount'>
                                            {invoice.invoiceAmount ? format(invoice.invoiceAmount, 0) : ''}{' '}
                                        </td>
                                        <td className='padding-right-10px invoice-number'>{invoice.invoiceNumber}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className='divider-sum'>
                                <tr>
                                    <td colSpan='1'></td>
                                    <td colSpan='1'></td>
                                    <td className='font-weight-bold align-right'>
                                        {customerInvoiceInfo.invoiceInformation
                                            ? getResults(searchValue, customerInvoiceInfo.invoiceInformation).sumHours
                                            : ''}
                                    </td>
                                    <td className='font-weight-bold float-right mr-2 align-right'>
                                        {customerInvoiceInfo.invoiceInformation
                                            ? getResults(searchValue, customerInvoiceInfo.invoiceInformation).sumAmount
                                            : ''}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    ) : (
                        <p className='text-center margin-0 padding-top-30px table-border'>
                                {t(CUSTOMER_INVOICE_INFO_NO_INVOICE_WARN)}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}
